import { createContext, useContext } from 'react'

export type Theme = 'light' | 'dark'

export type ResolvedTheme = 'light' | 'dark'

export type ThemeContextValue = {
  theme: Theme
  resolvedTheme: ResolvedTheme
  setTheme: (theme: Theme) => void
  pushForcedTheme: (theme: ResolvedTheme) => () => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme(): ThemeContextValue {
  const ctx = useContext(ThemeContext)
  if (!ctx) throw new Error('useTheme must be used within <ThemeProvider>')
  return ctx
}
